import { render, staticRenderFns } from "./failPass.vue?vue&type=template&id=8a4fa07c&scoped=true"
import script from "./failPass.vue?vue&type=script&lang=js"
export * from "./failPass.vue?vue&type=script&lang=js"
import style0 from "./failPass.vue?vue&type=style&index=0&id=8a4fa07c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4fa07c",
  null
  
)

export default component.exports